module.exports = __webpack_public_path__ + "img/40.1bca2869.jpg";